/**
 * Load and interpret store data.
 */
import debug from "./debug";
import api from "./api";
import { ReactSelectOptionObject } from "../components/InputSelectCustom";
export let TITLES: ReactSelectOptionObject[] = [];

/**
 * Load the store data from a URL (string) or from an array of LocalBusiness objects.
 */
export async function loadTitles(
  input?: null | ReactSelectOptionObject[]
): Promise<ReactSelectOptionObject[]> {
  // Already loaded
  if (TITLES.length) {
    return TITLES;
  }

  // Load using dataset given
  if (input instanceof Array) {
    debug("[utils/titles] Using supplied titles data", { input });

    TITLES = input;
  }
  // Use the API
  else {
    //debug("[utils/titles] Loading the titles data from API");

    const receivedTitles = await api.getTitles();
    TITLES = receivedTitles;
  }

  return TITLES;
}

export function getTitleLabelKey(titleValue: string): string {
  const filtered = TITLES.filter(title => title.value === titleValue);
  if (filtered.length) {
    return filtered[0].label;
  }
  return "";
}

export default TITLES;
